import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auth-handle',
  templateUrl: './auth-handle.component.html',
  styleUrls: ['./auth-handle.component.css']
})
export class AuthHandleComponent implements OnInit {

  constructor(private activatedActivated: ActivatedRoute) {}
  
  action = this.activatedActivated.snapshot.queryParams['mode'];

  
  ngOnInit(): void {
  }

}
